import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useToast } from 'context/ToastContext';
import * as apiWarehouses from 'api/apiWarehouses';
import CreateTeamForm from './CreateTeamForm';

interface CreateTeamFormikProps {
    setShow: (show: boolean) => void;
    onCreated: () => Promise<void>;
}

const CreateTeamFormik = ({ setShow, onCreated }: CreateTeamFormikProps) => {
    const { t } = useTranslation(['Warehouses', 'common']);
    const { showToast } = useToast();

    return (
        <Formik
            initialValues={{ teamName: '' }}
            onSubmit={async (values, { resetForm, setFieldError }) => {
                const resCreate = await apiWarehouses.createTeam(values.teamName);
                if (resCreate?.stat) {
                    await onCreated();
                    resetForm();
                    setShow(false);
                    showToast(t('createTeam.messCreated'), 'success');
                    return;
                }

                if (resCreate?.errCode === 'DUPLICATE_NAME') {
                    setFieldError('teamName', t('createTeam.messDuplicate'));
                    return;
                }

                if (resCreate?.errCode === 'EMPTY_NAME') {
                    setFieldError('teamName', t('createTeam.messEmpty'));
                    return;
                }

                showToast(t('common:messError'), 'danger');
            }}
        >
            {({ handleSubmit, isSubmitting, errors, touched }) => (
                <CreateTeamForm
                    handleSubmit={handleSubmit}
                    isSubmitting={isSubmitting}
                    error={touched.teamName && errors.teamName ? errors.teamName : ''}
                />
            )}
        </Formik>
    );
};

export default CreateTeamFormik;
